import HeaderTop from "./components/HeaderTop.jsx";
import HeaderMain from "./components/HeaderMain.jsx";
import SideFloatingBar from "./components/SideFloatingBar.jsx";
import Footer from "./components/Footer.jsx";
import ScrollToTop from "./components/ScrollToTop.jsx";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import Home from "./pages/Home.jsx";
import About from "./pages/About.jsx";
import Presentacion from "./pages/Presentacion.jsx";
import MisionVision from "./pages/MisionVision.jsx";
import Contacto from "./pages/Contact.jsx";
import OrganizacionInstitucional from "./pages/OrganizacionInstitucional.jsx";
import Autoridades from "./pages/Autoridades.jsx";
import PlanaDoc from "./pages/PlanaDocente.jsx";
import LocalInstitucional from "./pages/LocalInstitucional.jsx";

import Civil from "./pages/ConstruccionCivil.jsx";
import Contabilidad from "./pages/Contabilidad.jsx";
import DesarrolloSistemas from "./pages/DesarrolloSistemas.jsx";
import ElectricidadIndustrial from "./pages/ElectricidadIndustrial.jsx";
import ElectronicaIndustrial from "./pages/ElectronicaIndustrial.jsx";
import GestionAdministrativa from "./pages/GestionAdministrativa.jsx";
import MecanicaProduccion from "./pages/MecanicaProduccion.jsx";
import MecatronicaAutomotriz from "./pages/MecatronicaAutomotriz.jsx";
import DirectorSection from "./pages/DirectorSection.jsx";

import Admision from "./pages/Admision.jsx";
import Becas from "./pages/becas.jsx";

import Inversiones from "./pages/Inversiones.jsx";

import Licenciamiento from "./pages/Licenciamiento.jsx";

import DocumentosGestion from "./pages/DocumentosGeston.jsx";
import Comunicados from "./pages/Comunicados.jsx";

import BolsaLaboral from "./pages/BolsaLaboral.jsx";

import EnlacesInstitucionales from "./pages/EnlacesInstitucionales.jsx";

import AdminWrapper from "./components/AdminWrapper.jsx";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <HeaderTop/>
      <HeaderMain/>
      <SideFloatingBar/>
     
      <Routes>
        <Route path="/" element={<Home />} />
        
        <Route path="/nosotros/presentacion" element={<Presentacion />} />
        <Route path="/nosotros/mision" element={<MisionVision />} />
        <Route path="/contactanos/contact" element={<Contacto />} />
        <Route path="/nosotros/planaDocente" element={<PlanaDoc/>} />
        <Route path="/nosotros/organizacion" element={<OrganizacionInstitucional/>} />
        <Route path="/nosotros/autoridades" element={<Autoridades/>} />
        <Route path="/nosotros/local" element={<LocalInstitucional/>} />


        <Route path="/programas/construccion-civil" element={<Civil />} />
        <Route path="/programas/contabilidad" element={<Contabilidad />} />
        <Route path="/programas/desarrollo-de-sistemas-de-informacion" element={<DesarrolloSistemas />} />
        <Route path="/programas/electricidad-industrial" element={<ElectricidadIndustrial />} />
        <Route path="/programas/electronica-industrial" element={<ElectronicaIndustrial />} />
        <Route path="/programas/gestion-administrativa" element={<GestionAdministrativa />} />
        <Route path="/programas/mecanica-de-produccion-industrial" element={<MecanicaProduccion />} />
        <Route path="/programas/mecatronica-automotriz" element={<MecatronicaAutomotriz />} />

        <Route path="/admision-matricula/admision" element={<Admision/>} />
        <Route path="/admision-matricula/becas" element={<Becas/>} />



        <Route path="/nosotros/director" element={<DirectorSection />} />
        <Route path="/transparencia/doc_gestion" element={<DocumentosGestion />} />
        <Route path="/transparencia/inversiones" element={<Inversiones/>} />
        <Route path="/transparencia/licenciamiento" element={<Licenciamiento/>} />


        <Route path="/otrasPaginas/comunicados" element={<Comunicados />} />

        <Route path="/nosotros" element={<About />} />

        <Route path="/servicios/bolsa" element={<BolsaLaboral/>} />
        <Route path="/otrasPaginas/enlaces" element={<EnlacesInstitucionales/>} />

        


        
        <Route path="/admin" element={<AdminWrapper />} />
        
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
